import { render, staticRenderFns } from "./ThirdPartyOrdersView.vue?vue&type=template&id=55d20e32&"
import script from "./ThirdPartyOrdersView.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyOrdersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports